import { createStore } from 'redux';
import rootReducer from './reducers';

// React-Redux Store
const store = createStore(rootReducer);

export default store;